import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=4c351f26&scoped=true&"
import script from "./PostDetails.vue?vue&type=script&lang=js&"
export * from "./PostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c351f26",
  null
  
)

export default component.exports